import { tourEventBus } from './onboardingAssistant.js';

/**
 * @param {{
 *   tourId: string,
 *   action: string,
 *   stepIndex?: number,
 *   persona?: string,
 *   currentStep?: string,
 * }} payload
 */
export function emitTourEvent(payload) {
  tourEventBus.emit({
    ...payload,
    at: new Date().toISOString(),
  });
}
